var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 1.2,
    width: 17.6,
    height: 17.6,
    rx: 4.8,
    fill: "#F7F9FB",
    stroke: "#E2E8EE",
    strokeWidth: 2.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBorder);
export default __webpack_public_path__ + "static/media/checkBorder.3eb5eef3613e874513dd87ba32df3234.svg";
export { ForwardRef as ReactComponent };